import React from "react";
import {
  Box,
  Button,
  Grid,
  Link,
  Paper,
  TextField,
  Typography,
} from "@mui/material";

export default function PersonalAndBusinessCard() {
  return (
    <>
      <Box>
        <Grid
          container
          spacing={1}
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            height: "auto",
            // border: "1px solid red",
          }}
        >
          <Grid item xl={5} lg={6} md={6} sm={12} xs={12}>
            <Box
              sx={{
                width: "100%",
                height: { lg: "auto", md: "auto", sm: "auto", xs: "auto" },
                // height: "auto",
                background: "#B4EED6",
                borderRadius: "8px",
                // padding: "16px",
                // paddingLeft: "16px",
                paddingBottom: {
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },

                // paddingBottom: "16px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: "39.84px",
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
              >
                <Box sx={{}}>
                  <img
                    src="./images/Group 688.svg"
                    alt=""
                    width="60.96px"
                    height="72.58px"
                  />
                </Box>
                <Box sx={{}}>
                  <Link component="button">
                    <img
                      src="./images/LightGreenArrow.svg"
                      alt=""
                      width="40px"
                      height="40px"
                    />
                  </Link>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "20px",
                      xs: "18px",
                    },
                    // lineHeight: "36px",
                    letterSpacing: "0.01em",
                    color: "#1A1824",
                    paddingLeft: "16px",
                    // marginTop: "7.59px"
                  }}
                >
                  Personal
                </Typography>
                <Typography
                  sx={{
                    marginTop: "8px",
                    fontWeight: "400",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "16px",
                      xs: "14px",
                    },
                    lineHeight: "145%",
                    letterSpacing: "0.015em",
                    color: "#545359",
                    // width: "572px",
                    height: "52px",
                    paddingLeft: "16px",
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xl={5} lg={6} md={6} sm={12} xs={12}>
            <Box
              sx={{
                width: "100%",
                height: { lg: "auto", md: "auto", sm: "auto", xs: "auto" },
                background: "#E7ECFE",
                borderRadius: "8px",
                // padding: "16px",
                // paddingLeft: "16px",
                // paddingBottom: "16px",
                // marginTop: "24px",

                paddingBottom: {
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingTop: "39.84px",
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
              >
                <Box sx={{}}>
                  <img
                    src="./images/Group 688.svg"
                    alt=""
                    width="60.96px"
                    height="72.58px"
                  />
                </Box>
                <Box sx={{}}>
                  <Link component="button">
                    <img
                      src="./images/purpleaArrow.svg"
                      alt=""
                      width="40px"
                      height="40px"
                    />
                  </Link>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "20px",
                      xs: "18px",
                    },
                    // lineHeight: "36px",
                    letterSpacing: "0.01em",
                    color: "#1A1824",
                    paddingLeft: "16px",
                    // marginTop: "7.59px"
                  }}
                >
                  Business
                </Typography>
                <Typography
                  sx={{
                    marginTop: "8px",
                    fontWeight: "400",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "16px",
                      xs: "14px",
                    },
                    lineHeight: "145%",
                    letterSpacing: "0.015em",
                    color: "#545359",
                    // width: "572px",
                    height: "52px",
                    paddingLeft: "16px",
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* <Box spacing={1} sx={{ display: "flex", flexDirection: "row", marginTop: "24px" }}> */}
      <Box>
        <Grid
          container
          spacing={1}
          marginTop={"24px"}
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <Grid item xl={3.34} lg={4} md={4} sm={12} xs={12}>
            <Box
              sx={{
                // width: "416px",
                height: { lg: "auto", md: "auto", sm: "auto", xs: "auto" },
                background: "#FFF1B4",
                borderRadius: "8px",
                // padding: "16px",
                // marginLeft: "24px",
                // paddingBottom: "16px",

                paddingBottom: {
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingTop: "39.84px",
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
              >
                <Box>
                  <img
                    src="./images/multipleCuisine.svg"
                    alt=""
                    width="87.75px"
                    height="82.81px"
                  />
                </Box>
                <Box sx={{}}>
                  <Link component="button">
                    <img
                      src="./images/yellowArrow.svg"
                      alt=""
                      width="40px"
                      height="40px"
                    />
                  </Link>
                </Box>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "20px",
                      xs: "18px",
                    },
                    // lineHeight: "36px",
                    letterSpacing: "0.01em",
                    color: "#1A1824",
                    paddingLeft: "16px",

                    // marginTop: "7.59px"
                  }}
                >
                  Multiple Cuisine
                </Typography>
                <Typography
                  sx={{
                    marginTop: "8px",
                    fontWeight: "400",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "16px",
                      xs: "14px",
                    },
                    lineHeight: "145%",
                    letterSpacing: "0.015em",
                    color: "#545359",
                    // width: "384px",
                    height: "78px",
                    paddingLeft: "16px",
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                </Typography>
              </Box>
            </Box>
          </Grid>
          {/* </Box> */}

          <Grid item xl={3.34} lg={4} md={4} sm={12} xs={12}>
            <Box
              sx={{
                // width: "416px",
                height: { lg: "auto", md: "auto", sm: "auto", xs: "auto" },
                background: "#C9E3BC",
                borderRadius: "8px",
                // padding: "16px",
                // marginLeft: "24px",
                paddingBottom: {
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingTop: "39.84px",
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
              >
                <Box sx={{}}>
                  <img
                    src="./images/multipleCuisine.svg"
                    alt=""
                    width="87.75px"
                    height="82.81px"
                  />
                </Box>
                <Box sx={{}}>
                  <Link component="button">
                    <img
                      src="./images/greenArrow.svg"
                      alt=""
                      width="40px"
                      height="40px"
                    />
                  </Link>
                </Box>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "20px",
                      xs: "18px",
                    },
                    // lineHeight: "36px",
                    letterSpacing: "0.01em",
                    color: "#1A1824",
                    paddingLeft: "16px",

                    // marginTop: "7.59px"
                  }}
                >
                  Fitness
                </Typography>
                <Typography
                  sx={{
                    marginTop: "8px",
                    fontWeight: "400",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "16px",
                      xs: "14px",
                    },
                    lineHeight: "145%",
                    letterSpacing: "0.015em",
                    color: "#545359",
                    // width: "384px",
                    height: "78px",
                    paddingLeft: "16px",
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xl={3.34} lg={4} md={4} sm={12} xs={12}>
            <Box
              sx={{
                // width: "100%",
                height: { lg: "auto", md: "auto", sm: "auto", xs: "auto" },
                background: "#82CDF8",
                borderRadius: "8px",
                // padding: "16px",
                // marginLeft: "24px",
                // marginRight: "72px",
                paddingBottom: {
                  lg: "16px",
                  md: "16px",
                  sm: "16px",
                  xs: "16px",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  paddingTop: "39.84px",
                  paddingLeft: "32px",
                  paddingRight: "32px",
                }}
              >
                <Box sx={{}}>
                  <img
                    src="./images/multipleCuisine.svg"
                    alt=""
                    width="87.75px"
                    height="82.81px"
                  />
                </Box>
                <Box sx={{}}>
                  <Link component="button">
                    <img
                      src="./images/blueArrow.svg"
                      alt=""
                      width="40px"
                      height="40px"
                    />
                  </Link>
                </Box>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: {
                      lg: "24px",
                      md: "24px",
                      sm: "20px",
                      xs: "18px",
                    },
                    // lineHeight: "36px",
                    letterSpacing: "0.01em",
                    color: "#1A1824",
                    paddingLeft: "16px",

                    // marginTop: "7.59px"
                  }}
                >
                  Event
                </Typography>
                <Typography
                  sx={{
                    marginTop: "8px",
                    fontWeight: "400",
                    fontSize: {
                      lg: "18px",
                      md: "18px",
                      sm: "16px",
                      xs: "14px",
                    },
                    lineHeight: "145%",
                    letterSpacing: "0.015em",
                    color: "#545359",
                    // width: "384px",
                    height: "78px",
                    paddingLeft: "16px",
                  }}
                >
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
